import React from "react";
import Blogs from "../../components/Blog";

const BlogPage = () => {
  document.title = "Blog || ls-healthcare";
  return <Blogs />;
};

export default BlogPage;
